import { useEffect, useRef } from "react";

/**
 * usePolling - runs a given function immediately and then on a set interval,
 * if enabled.
 *
 * @param callback - The function to execute.
 * @param interval - Polling interval in milliseconds.
 * @param enabled - Whether polling should be active.
 */
export function usePolling(callback: () => void, interval: number, enabled = true) {
  const savedCallback = useRef(callback);

  // Keep a fresh reference to the callback
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  useEffect(() => {
    if (!enabled) return;

    // Run immediately on mount or when enabled changes to true
    savedCallback.current();

    // Set up polling
    const id = setInterval(() => {
      savedCallback.current();
    }, interval);

    // Clear on unmount or when disabled
    return () => clearInterval(id);
  }, [interval, enabled]);
}
